import React, { memo } from 'react';
import css from './ShippingDetailsForm.module.css';
import { FieldRadioButton } from '../../../components';

const RenderNonUsOptions = ({ intl }) => (
  <div className={css.nonUSOptionSec}>
    <span className={css.nonUSOptionsHeading}>
      {intl.formatMessage({ id: 'ShippingDetailsForm.heading' })}
    </span>
    <div className={css.nonUSOptions}>
      {['yes', 'no'].map(value => (
        <FieldRadioButton
          key={value}
          id={`enableNonUSOrders${value}`}
          name="enableNonUSOrders"
          label={intl.formatMessage({ id: `ShippingDetailsForm.${value}` })}
          value={value}
        />
      ))}
    </div>
  </div>
);

export default memo(RenderNonUsOptions);
